import { useEffect, useRef, useState } from "react"

import { isClientSide } from "@utils"

const useIsBeaconReady = () => {
  const TimeoutRef = useRef<NodeJS.Timeout | number | null>(null)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (!isClientSide()) return

    const waitForBeaconLoop = () => {
      if (window.Beacon) {
        setIsReady(true)
        return
      }
      TimeoutRef.current = setTimeout(waitForBeaconLoop, 200)
    }

    TimeoutRef.current = setTimeout(waitForBeaconLoop, 200)

    return () => {
      if (TimeoutRef.current) clearTimeout(TimeoutRef.current)
    }
  }, [])

  return isReady
}

export default useIsBeaconReady
